const initialState = {
    data: [], 
    special:[],
    sick:[],
    name:[],
    country:[],
    edit:[], 
    remove:[],
  
  };
  
  const SupDoctorsReucers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_SPEC_SUCCESS':
            return {... state, special:action.payload};
            case 'FETCH_SIC_SUCCESS':
            return {... state, sick:action.payload};
            case 'FETCH_NAME_SUCCESS':
            return {... state, name:action.payload};
            case 'FETCH_COUN_SUCCESS':
            return {... state, country:action.payload};
            case 'FETCH_EDIT_SUCCESS':
            return {... state, edit:action.payload};
            case 'FETCH_REMOVE_SUCCESS':
              return {... state, remove:action.payload};
            
           
          


      default:
        return state;
    }
  };
  
  export default SupDoctorsReucers;
  
  